import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class LwProductService {

	constructor() { }
	findIcon(productCode) {
		switch (productCode) {
			case 'L2':
				return 'icon-l2_link_plus';
			case 'LW921':
			case 'LW921E':
				return 'icon-lw921_thermostat';
			case 'L23':
			case 'L23EU':
				return 'icon-l23_dimmer_3gang';
			case 'L24EU':
			case 'L24':
				return 'icon-l24_dimmer_4gang';
			case 'LW100':
			case 'LW104':
			case 'LW928':
			case 'LW929':
				return 'icon-lw100_lw104_remote';
			case 'LW830':
			case 'LW831':
				return 'icon-lw830_831_in_line_relay';
			case 'LW922':
				return 'icon-lw922_trv';
			case 'LW821':
				return 'icon-lw821_in_line_relay';
			case 'LW825':
				return 'icon-lw825_in_line_relay';
			case 'LW842':
				return 'icon-lw842_outdoor_switch_2gang';
			case 'LW920':
			case 'LW934':
				return 'icon-lw920_lw934_electric_boiler_switch';
			case 'LW904':
				return 'icon-lw904_mag_switch';
			case 'LW430':
				return 'icon-lw430_dimmer_3gang';
			case 'LW420':
			case 'LW452':
			case 'LW455':
				return 'icon-lw420_lw452_lw455_dimmer_2gang';
			case 'LW842':
				return 'lw842_outdoor_switch_2gang';
			case 'LW841':
				return 'icon-lw841_outdoor_switch_1gang';
			case 'LW270':
				return 'icon-lw270_socket_2gang';
			case 'LW107':
				return 'icon-lw107_movement_sensor';
			case 'L41':
				return 'icon-l41_socket_1gang';
			case 'LW400':
			case 'LW450':
				return 'icon-lw400_lw450_dimmer_1gang';
			case 'L22':
			case 'L22EU':
				return 'icon-l22_dimmer_2gang';
			case 'L42':
				return 'icon-l42_socket_2gang';
			case 'LW440':
				return 'icon-lw440_dimmer_4gang';

			case 'LW600':
				return 'icon-lw600_energy_monitor';
			case 'L23':
			case 'L23EU':
				return 'icon-l23_dimmer_3gang';
			case 'LW221':
				return 'lw221_wire_free_switch_2gang';
			case 'L21':
			case 'L21EU':
				return 'icon-l21_dimmer_1gang';
			case 'LW931':
				return 'icon-lw931_mag_trigger';
			case 'LW321':
			case 'LW301':
			case 'LW320':
			case 'LW300':
				return 'icon-lw321_lw301_plug_in_dimmer';

			case 'LW260':
				return 'icon-lw260_socket_1gang';
			case 'L71':	
			default:
				return 'icon-signal_0';
		}
	}

	findType(productCode): string {
		switch (productCode) {
			case 'L2':
				return 'Link Plus';
			case 'LW921':
			case 'LW921E':
			case 'LW922':
			case 'LW920':
			case 'LW934':
			case 'L92':
			case 'L92R':
			case 'L92MK2':
			case 'AHC':
			case 'AHM':
			case 'ARC':
			case 'AFSV':
			case 'AFS':
			case 'HR91':
			case 'HR92':
			case 'T87RF':
			case 'EVO':
			case 'DT92E':
			case 'BRD91':
				return 'Smart Heating';
			case 'LW100':
			case 'LW104':
			case 'LW928':
			case 'LW929':
				return 'Remote Control';
			case 'LW830':
			case 'LW831':
			case 'LW821':
			case 'LW825':
			case 'L81':
			case 'L82':
			case 'L82MK2':
			case 'L83':
			case 'L83MK2':
			case 'ASW1':
			case 'ASW2':
				return 'Relay';
			case 'LW842':
			case 'LW841':
			case 'LW221':
				return 'Connect Switch';
			case 'LW904':
			case 'LW931':
				return 'Magnetic Switch';
			case 'LW430':
			case 'LW420':
			case 'LW452':
			case 'LW455':
			case 'LW400':
			case 'LW450':
			case 'LW440':
			case 'LW321':
			case 'LW301':
			case 'LW320':
			case 'LW300':
				return 'Connect Dimmer';
			case 'LW270':
			case 'LW260':
				return 'Connect Socket';
			case 'LW107':
				return 'Smart Sensor';
			case 'L41':
			case 'L41TE':
			case 'L41TF':
			case 'L41TG':
			case 'L42':
			case 'L42MK2':
			case 'L42MK3':
				return 'Smart Socket';
			case 'LW600':
				return 'Energy Monitor';
			case 'L21':
			case 'L21EU':
			case 'L21MK2':
			case 'L21MK3':
			case 'L22':
			case 'L22EU':
			case 'L22MK2':
			case 'L22MK3':
			case 'L23':
			case 'L23MK3':
			case 'L24':
			case 'L24MK3':
				return 'Smart Dimmer';
			case 'LW931':
			case 'L71':
				return 'Magnetic Trigger';
			case 'L51':
			case 'L52':
			case 'L53':
			case 'L54':
				return 'Smart Wirefree';
			case 'L70':
			case 'L70MK2':
				return 'PIR';
			case 'LW380':
			case 'L40TE':
			case 'L40TF':
			case 'L40TG':
			case 'L40':
			case 'L40MK2':
				return 'Plug-In';
			default:
				return 'other';
		}


	}

	findAvailableFeature(productCode): any[] {
		switch (productCode) {
			case 'L2':
				return ['link+'];
			case 'LW921':
			case 'LW921E':
				return ['temperature', 'target', 'output level'];
			case 'LW100':
			case 'LW104':
			case 'LW928':
			case 'LW929':
				return ['remote'];
			case 'LW830':
			case 'LW831':
				return ['relay'];
			case 'LW922':
				return ['temperature', 'target', 'valve level'];
			case 'LW821':
				return ['relay'];
			case 'LW825':
				return ['relay'];
			case 'LW842':
				return ['switch'];
			case 'LW920':
			case 'LW934':
				return ['temperature', 'target', 'switch'];
			case 'LW904':
				return ['switch'];
			case 'LW430':
				return ['dim level', 'switch'];
			case 'LW420':
			case 'LW452':
			case 'LW455':
				return ['dim level', 'switch'];
			case 'LW842':
				return ['switch'];
			case 'LW841':
				return ['switch'];
			case 'LW270':
				return ['socket'];
			case 'LW107':
				return ['sensor'];
			case 'L41':
				return ['dim level', 'switch', 'energy'];
			case 'LW400':
			case 'LW450':
				return ['dim level', 'switch'];
			case 'L22':
				return ['dim level', 'switch', 'energy', 'power'];
			case 'L42':
				return ['dim level', 'switch', 'energy', 'power'];
			case 'LW440':
				return ['dim level', 'switch'];

			case 'LW600':
				return ['energy', 'power'];
			case 'L23':
				return ['dim level', 'switch', 'energy', 'power'];
			case 'LW221':
				return ['switch'];
			case 'L21':
				return ['dim level', 'switch', 'energy', 'power'];
			case 'LW931':
				return ['switch'];
			case 'LW321':
			case 'LW301':
			case 'LW320':
			case 'LW300':
				return ['dim level', 'switch'];

			case 'LW260':
				return ['switch'];
			default:
				return ['unknown error'];
		}
	}

	findFeatureMiniIcons(featureName) {
		switch (featureName) {
			case 'energy':
				return '/lw-dashboard/assets/lightning-electric-energy.svg';
			case 'dim level':
			case 'target':
			case 'output level':
			case 'valve level':
			case 'power':
				return '/lw-dashboard/assets/stais.svg';
			case 'switch':
				return '/lw-dashboard/assets/switch.svg';
			case 'temperature':
				return '/lw-dashboard/assets/fire.svg';
			default:
		}     return '/lw-dashboard/assets/fire.svg';
	}

	findFixedMargin(productCode) {
		switch (productCode) {
			case 'icon-l42_socket_2gang':
			case 'icon-l23_dimmer_3gang':
			case 'icon-l24_dimmer_4gang':
				return null;
			default:
				return '16px';
		}

	}

	findFixedMargin_center_box(productCode) {
		switch (productCode) {
			case 'icon-l42_socket_2gang':
			case 'icon-l23_dimmer_3gang':
			case 'icon-l24_dimmer_4gang':
				return '-26px';
			default:
				return null;
		}

	}


	findFixedMargin_device_card(productCode) {
		switch (productCode) {
			case 'icon-l42_socket_2gang':
			case 'icon-l23_dimmer_3gang':
			case 'icon-l24_dimmer_4gang':
				return '4px';
			default:
				return '16px';
		}

	}

	setDeviceType(productCode) {
		switch (productCode) {
			case 'LW921E':
				return 'thermoE'
				break;
			case 'LW921':
			case 'AHM':
			case 'AFSV':
			case 'AFS':
			case 'T87RF':
			case 'EVO':
			case 'DT92E':
				return 'thermo'
				break;
			case 'LW931':
				return 'mag_trigger'
				break;
			case 'L70':
			case 'L70MK2':
				return 'PIR'
				break;
			case 'LW922':
			case 'ARC':
			case 'HR91':
			case 'HR92':
				return 'TRV'
				break;
			default:
				return 'temperature'
		}
	}
}
